<template>
  <div class="flex items-center justify-end px-3 border-b border-white/10 shrink-0">
    <UButton
      label="Remove sort"
      color="neutral"
      variant="ghost"
      size="sm"
      icon="i-lucide-list-x"
      :disabled="!active"
      @click="$emit('reset')"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{ active: boolean }>()
defineEmits<{ (e: 'reset'): void }>()
</script>
